import { connect } from 'react-redux'

import { getMenuRecipeForDetails } from '../../selectors/menuRecipeDetails'
import { RecipeMeta } from './RecipeMeta'

const mapStateToProps = ({ recipesV3, menuRecipeDetails }) => ({
  recipe: getMenuRecipeForDetails({ recipesV3, menuRecipeDetails }),
})

export const DetailRecipeMetaContainer = connect(mapStateToProps)(RecipeMeta)
